import { SharesStats } from "../types";

export function calculateEfficiency(shares?: SharesStats) {
  if (!shares || shares.accepted === 0 || shares.rejected === 0) {
    return Number(0).toFixed(2);
  }
  const totalShares = shares.accepted + shares.rejected;
  return ((shares.accepted / totalShares) * 100).toFixed(2);
}
